import { useMemo } from "react";
import { BoundarySource } from "../../../constant/BoundarySource";
import { ToolsType } from "../../../constant/ToolsType";
import { useBoundarySelectContext } from "../../boundarySelection/BoundarySelectContext";
import { DrawPolygon } from "../../reactOL/interactions";
import { OLParser } from "../../reactOL/JSTS/OL";
import olVectorSource from "ol/source/Vector";

const DrawCustomBoundary = () => {
  const { boundaries, addBoundary, activeTool, setActiveTool } =
    useBoundarySelectContext();

  const toolsSource = useMemo(() => new olVectorSource(), []);

  const handleDrawEnd = (polygon: jsts.geom.Polygon) => {
    const newId =
      boundaries.filter(
        (b) =>
          b.source === BoundarySource.DrawnBoundary ||
          b.source === BoundarySource.UploadedBoundary,
      ).length *
        -1 -
      1;
    addBoundary({
      boundaryId: newId,
      name: "Drawn Boundary",
      geometry: OLParser.write(polygon),
      source: BoundarySource.DrawnBoundary,
      isCustom: false,
    });
    setActiveTool(ToolsType.NONE);
  };

  return (
    <DrawPolygon
      source={toolsSource}
      active={
        activeTool === ToolsType.DRAW_POLYGON ||
        activeTool === ToolsType.DRAW_FREEHAND_POLYGON
      }
      onDrawEnd={handleDrawEnd}
      freehand={activeTool === ToolsType.DRAW_FREEHAND_POLYGON}
    />
  );
};

export default DrawCustomBoundary;
